// src/store/mappers/sixCatalog/index.ts

import type { SixCatalogItemDTO, SixesCatalogPayloadDTO, PaginationDTO } from '@/types/SixCatalogDTOs';
import { PENDING_HAP_STATUS, type SixCatalogItem, type Pagination, type SixStatus } from '@/types/Sixes';

const VALID_SIX_STATUSES: Record<string, SixStatus> = {
  Active: 'Active',
  Inactive: 'Inactive',
  Archived: 'Archived',
  [PENDING_HAP_STATUS]: PENDING_HAP_STATUS,
};

const DEFAULT_SIX_STATUS: SixStatus = 'Active';

function toSixStatus(value: string): SixStatus {
  return VALID_SIX_STATUSES[value] ?? DEFAULT_SIX_STATUS;
}

/**
 * Maps a single SIX catalog item DTO to FE model
 */
export function mapSixCatalogItemDTOToSixCatalogItem(dto: SixCatalogItemDTO): SixCatalogItem {
  return {
    id: dto.id,
    name: dto.name,
    description: dto.description,
    status: toSixStatus(dto.status),
    isFavorite: dto.isFavorite,
    isRecent: dto.isRecent,
    ownerCount: dto.ownerCount,
    isMySix: dto.isMySix,
    owners: dto.owners,
    participantCount: dto.participantCount,
    fileCount: dto.fileCount,
    swarmKey: dto.swarmKey,
    bootstrapNodes: dto.bootstrapNodes,
    createdAt: new Date(dto.createdAt),
    lastModified: new Date(dto.lastModified),
    lastAccessed: new Date(dto.lastAccessed),
  };
}

/**
 * Maps pagination DTO to FE model
 */
export function mapPaginationDTOToPagination(dto: PaginationDTO): Pagination {
  return {
    page: dto.page,
    pageSize: dto.pageSize,
    totalItems: dto.totalItems,
    totalPages: dto.totalPages,
  };
}

/**
 * Result of mapping the catalog response
 */
export interface MappedSixesCatalogResponse {
  sixes: SixCatalogItem[];
  pagination?: Pagination;
}

/**
 * Maps the full catalog payload DTO to FE model
 */
export function mapSixesCatalogPayloadDTOToResponse(dto: SixesCatalogPayloadDTO): MappedSixesCatalogResponse {
  return {
    sixes: dto.sixes.map(six => mapSixCatalogItemDTOToSixCatalogItem(six)),
    pagination: mapPaginationDTOToPagination(dto.pagination),
  };
}
